import { render, staticRenderFns } from "./Step0.vue?vue&type=template&id=5082951b&scoped=true"
import script from "./Step0.vue?vue&type=script&lang=js"
export * from "./Step0.vue?vue&type=script&lang=js"
import style0 from "./Step0.vue?vue&type=style&index=0&id=5082951b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5082951b",
  null
  
)

export default component.exports